import React, { useEffect, useRef } from 'react';

interface IndeterminateCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    /** Some, not all, of what the box governs is checked (a DOM property, not an attribute) */
    indeterminate: boolean;
}

/** A checkbox that can show the indeterminate state */
export const IndeterminateCheckbox: React.FC<IndeterminateCheckboxProps> = ({ indeterminate, ...props }) => {
    const ref = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (ref.current) ref.current.indeterminate = indeterminate;
    }, [indeterminate]);
    return <input ref={ref} type="checkbox" {...props} />;
};
